//Determine if mobile
export function IsMobile() {
    var mobile = false;

    if ((navigator.userAgent.match(/Mobi/) && $(window).width() < 992 ) || $(window).width() < 992) {
        mobile = true;
    } else {
        mobile = false;
    }
    return mobile;
}